import * as React from 'react';

import Time from 'components/Time';

import Text from 'components/Text';
import { Props as TextProps } from 'components/Text';

import getField from '../ComposableTableField';
import { Field } from '../ComposableTableField';

type Props = {
  content: any;
  textProps: Partial<TextProps>;
};

function TextCell({ content, textProps }: Props) {
  return <Text {...textProps}>{content}</Text>;
}

export function getTextCellGenerator<T>(field: Field<T>, textProps?: Partial<TextProps>) {
  return (data: T) => {
    return <TextCell content={getField(data, field)} textProps={textProps || {}} />;
  };
}

export function getArrayTextCellGenerator<T>(
  field: Field<T>,
  transformCallback?: (value: string) => string,
  textProps?: Partial<TextProps>
) {
  return (data: T) => {
    const content = getField(data, field).map((item: string) =>
      transformCallback ? transformCallback(item) : item
    );

    return <TextCell content={content.join(', ')} textProps={textProps || {}} />;
  };
}

export function getTimestampCellGenerator<T>(
  field: Field<T>,
  textProps?: Partial<TextProps>,
  prefix?: string
) {
  return (data: T) => {
    const fieldValue = getField(data, field);
    let content;

    if (!fieldValue || isNaN(new Date(fieldValue).getTime())) {
      // invalid
      content = null;
    } else {
      const time = (
        <Time
          date={new Date(fieldValue)}
          month="short"
          day="numeric"
          year="numeric"
          hour="numeric"
          minute="numeric"
          hour12
        />
      );
      content = prefix ? (
        <React.Fragment>
          {prefix} {time}
        </React.Fragment>
      ) : (
        time
      );
    }

    return <TextCell content={content} textProps={textProps || {}} />;
  };
}

export function getDatestampCellGenerator<T>(
  field: Field<T>,
  textProps?: Partial<TextProps>,
  prefix?: string
) {
  return (data: T) => {
    const fieldValue = getField(data, field);
    let content;

    if (!fieldValue || isNaN(new Date(fieldValue).getTime())) {
      // invalid
      content = null;
    } else {
      const time = <Time date={new Date(fieldValue)} month="short" day="numeric" year="numeric" />;
      content = prefix ? (
        <React.Fragment>
          {prefix} {time}
        </React.Fragment>
      ) : (
        time
      );
    }

    return <TextCell content={content} textProps={textProps || {}} />;
  };
}
